<template>
  <div class="container">
    <chart :chart-data="chartData" :options="options"/>
  </div>
</template>

<script>
import ApiService from "../service/ApiService";
import Chart from "../mixins/Chart";

export default {
  name: "ElectricChart",
  props: {
    period: {
      type: String,
      default: "12"
    }
  },
  components: { Chart },
  data: () => ({
    serialNumber: "205A414246303031353837303938363131",
    chartData: {
      datasets: [
        {
          label: "Power (snapshot)",
          backgroundColor: "rgba(60, 200, 60, 0.5)",
          borderColor: "rgba(30, 200, 32, 0)",
          borderWidth: 1
        },
        {
          type: "line",
          label: "Power import (average)",
          backgroundColor: "rgba(255, 60, 70, 0.1)",
          borderColor: "rgba(255, 60, 70, 0.8)",
          borderWidth: 2,
          pointRadius: 0
        },
        {
          type: "line",
          label: "Power export (average)",
          backgroundColor: "rgba(255, 170, 90, 0.1)",
          borderColor: "rgba(255, 170, 90, 0.8)",
          borderWidth: 2,
          pointRadius: 0
        }
      ]
    },
    options: {
      /*barThickness: 1,*/
      maxBarThickness: 1,
      barPercentage: 1.0,
      categoryPercentage: 0.2,
      maintainAspectRatio: false,
      scales: {
        xAxes: [
          {
            type: "time",
            time: {
              tooltipFormat: "D MMMM YYYY, HH:mm:ss",
              displayFormats: {
                hour: "D MMM HH:mm",
                minute: "HH:mm",
                second: "HH:mm:ss"
              }
            }
          }
        ],
        yAxes: [
          {
            ticks: {
              beginAtZero: true
            }
          }
        ]
      }
    }
  }),
  methods: {
    fetchData() {
        let currentTime = new Date().toISOString();
        let period = this.period;
        let serialNumber = this.serialNumber;

        ApiService.get(currentTime, period, serialNumber).then(response => {
          const data = response.intervalData;
          const snapshotdata = [];
          const averagedata = [];
          const averagedata_export = [];
          data.forEach(item => {
            snapshotdata.push({
              t: new Date(item.dateTime),
              y: item.currentPowerImport - item.currentPowerExport
            });
            averagedata.push({
              t: new Date(item.dateTime),
              y: item.averagePowerImport
            });
            averagedata_export.push({
              t: new Date(item.dateTime),
              y: -item.averagePowerExport
            });
          });
          this.chartData.datasets[0].data = snapshotdata;
          this.chartData.datasets[1].data = averagedata;
          this.chartData.datasets[2].data = averagedata_export;
          this.$root.$emit('update:chart');
      });
    }
  },
  mounted() {
    this.fetchData();
    this.$root.$on('updateSerialNumber', data => {
        console.log(data);
        this.serialNumber = data;
        this.fetchData();
    });
  }
};
</script>
<style>
.container {
  padding: 5px;
  height: 500px;
  position: relative;
}
</style>
